import React from "react";
import { motion } from "framer-motion";
import PageHero from "../components/PageHero";
import FinalCta from "../components/FinalCta";
import { STONE_TYPES, IMG } from "../lib/content";

export default function StoneTypes() {
  return (
    <main data-testid="stone-types-page">
      <PageHero
        eyebrow="Stone Types"
        title="Every stone has its"
        italic="own language."
        subtitle="Marble whispers, terrazzo sings, granite holds its weight. We speak each one fluently."
        image={IMG.harborView}
      />

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STONE_TYPES.map((s, i) => (
            <motion.div
              key={s.name + i}
              data-testid={`stone-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.06 }}
              className="group"
            >
              <div className="img-zoom-wrap aspect-[4/5]">
                <img
                  src={s.image}
                  alt={`${s.name} restoration`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-5 font-display-bold text-xl tracking-tight text-[#0A0A0A]">
                {s.name}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-[#525252]">
                {s.blurb}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      <FinalCta />
    </main>
  );
}
